import Lazyload from 'vanilla-lazyload';

if (!document.lazyLoadInstance) {
    document.lazyLoadInstance = new Lazyload({
        elements_selector: '.lazy',
    });
}
